import React from 'react';
import ReactLoading from 'react-loading';
import styles from './styles.scss';

interface BaseProps {
  content: string;
}

const LoadingBox: React.FC<BaseProps> = (props) => {
  const { content } = props;
  return (
    <div className={styles['mask-wrap']}>
      <div className={styles['loading-content']}>
        <ReactLoading width={20} height={20} type="spokes" color="#fff" />
        <p>{content}</p>
      </div>
    </div>
  );
};
export default LoadingBox;
